import React from "react"
import TabbedListingPage from "../Material/TabbedListingPage"
import LiabilityClaimListContainer from "./LiabilityClaimListContainer"
import SubrogationClaimListContainer from "./SubrogationClaimListContainer"
import ReportsPanel from "../Reports/ReportsPanel"
import { ROUTES } from "../Layout/routes"

// Both panels self-supply location/navigate via their own withApolloClient wrap
// and forward whatever they're given to their header/actions, so the only thing
// each actually needs from the page is currentUser. Reports needs neither --
// ReportsPanel owns its own date range, filters and view state.
const claimsTabs = [
    { id: "liability", name: "Liability", iconClassName: "fa fa-balance-scale", permissionRequired: null, render: ({ currentUser }) => <LiabilityClaimListContainer currentUser={currentUser} /> },
    { id: "subro", name: "Subro", iconClassName: "fa fa-file-text-o", permissionRequired: null, render: ({ currentUser }) => <SubrogationClaimListContainer currentUser={currentUser} /> },
    { id: "reports", name: "Activity Log", iconClassName: "fa fa-history", floatRight: true, iconOnly: true, permissionRequired: null, render: () => <ReportsPanel reportId="claims" /> },
]

const ClaimsPage = (props) => (
    <TabbedListingPage
        className="claimsPage"
        route={ROUTES.claims}
        tabs={claimsTabs.map(tab => ({ ...tab, render: () => tab.render({ currentUser: props.currentUser }) }))}
    />
)

export { claimsTabs }

export default ClaimsPage
